import CsvSourceEditPageReducer from './CsvSourceEditPageReducer';
import { CsvItemsTableReducers } from './containers/CsvItemsTable';

export default from './CsvSourceEditPageContainer';
export const CsvSourceEditPageReducers = {
  CsvSourceEditPageReducer,
  ...CsvItemsTableReducers,
};
